import { Component, OnInit, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ConstanteUri } from 'src/app/constants/constante-uri';
import { CcdLocaliteModelList } from '@cnaf.usagers.appli/cnaf-commons-dral';

@Component({
  selector: 'app-modale-code-postal-non-eligible',
  templateUrl: './modale-code-postal-non-eligible.component.html'
})
export class ModaleCodePostalNonEligibleComponent implements OnInit {

  modalRef!: BsModalRef;
  @ViewChild('modaleInterdiction') public modaleInterdiction: TemplateRef<any>;
  
  _afficheModale : boolean = false;

  @Input()
  set afficheModale(aff : boolean) {
    this._afficheModale = aff;
    if (aff) {
      this.activerModale();
    }
  }
  get afficheModale() : boolean {
    return this._afficheModale;
  }

  _localite : CcdLocaliteModelList;

  @Input()
  set localite(loc : CcdLocaliteModelList) {
    this._localite = loc;
  }
  get localite() : CcdLocaliteModelList {
    return this._localite;
  }

  @Output() onClose = new EventEmitter<boolean>();

  constructor(private modalService: BsModalService) { }

  ngOnInit(): void {
  }

  activerModale() {
    this.modalService.show(this.modaleInterdiction);
  }

  fermerModale() {
    this.modalService.hide();
    this.onClose.emit(true);
  }

  redirigerAccueil() {
    this.modalService.hide();
    window.location.assign(ConstanteUri.URL_REDIRECT_EXIT);
  }
}
